import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// sv
import svCommon from './data/sv/common.json'
import svCards from './data/sv/cards.json'
import svAntagonists from './data/sv/antagonists.json' 
// en
import enCommon from './data/en/common.json'
import enCards from './data/en/cards.json'
import enAntagonists from './data/en/antagonists.json'

// ar
import arCommon from './data/ar/common.json'
import arCards from './data/ar/cards.json'
import arAntagonists from './data/ar/antagonists.json'

// TODO: If we actually will do larger language management, 
// we should move this to an external resource, but not needed now
const resources = {
  sv: {
    cards: svCards,
    common: svCommon,
    antagonists: svAntagonists,
  },
  en: {
    cards: enCards,
    common: enCommon,
    antagonists: enAntagonists,
  },
  ar: {
    cards: arCards,
    common: arCommon,
    antagonists: arAntagonists,
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'sv',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
